module.exports = {
	"config": {
		"siteTitle": "Gatsby Stay Static Site Sample",
		"linkPrefix": "/sites/gatsby"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.js",
				"ext": "js",
				"name": "_template",
				"extname": ".js",
				"basename": "_template.js",
				"dirname": "",
				"stem": "_template",
				"path": "_template.js",
				"absolute": "C:\\Sites\\staystatic\\gatsby\\_template.js",
				"isAbsolute": false
			},
			"requirePath": "_template.js",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md",
				"absolute": "C:\\Sites\\staystatic\\gatsby\\404.md",
				"isAbsolute": false
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"title": "404 Not Found",
				"path": "/404.html"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "",
				"stem": "index",
				"path": "index.js",
				"absolute": "C:\\Sites\\staystatic\\gatsby\\index.js",
				"isAbsolute": false
			},
			"requirePath": "index.js",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "pages",
				"base": "about.md",
				"ext": "md",
				"name": "about",
				"extname": ".md",
				"basename": "about.md",
				"dirname": "pages",
				"stem": "about",
				"path": "pages\\about.md",
				"absolute": "C:\\Sites\\staystatic\\gatsby\\pages\\about.md",
				"isAbsolute": false
			},
			"requirePath": "pages/about.md",
			"path": "/about/",
			"data": {
				"title": "About",
				"path": "/about/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "posts",
				"base": "_template.js",
				"ext": "js",
				"name": "_template",
				"extname": ".js",
				"basename": "_template.js",
				"dirname": "posts",
				"stem": "_template",
				"path": "posts\\_template.js",
				"absolute": "C:\\Sites\\staystatic\\gatsby\\posts\\_template.js",
				"isAbsolute": false
			},
			"requirePath": "posts/_template.js",
			"templatePath": "/posts/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "posts",
				"base": "2014-11-11-new-repo-maps.md",
				"ext": "md",
				"name": "2014-11-11-new-repo-maps",
				"extname": ".md",
				"basename": "2014-11-11-new-repo-maps.md",
				"dirname": "posts",
				"stem": "2014-11-11-new-repo-maps",
				"path": "posts\\2014-11-11-new-repo-maps.md",
				"absolute": "C:\\Sites\\staystatic\\gatsby\\posts\\2014-11-11-new-repo-maps.md",
				"isAbsolute": false
			},
			"requirePath": "posts/2014-11-11-new-repo-maps.md",
			"path": "/posts/new-repo-maps/",
			"data": {
				"title": "beer.db - New Repo /maps - Free 'Full-Screen' Interactive Beer Maps w/ Brewery Listings",
				"layout": "post",
				"path": "/posts/new-repo-maps/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "posts",
				"base": "2014-12-12-new-build-system.md",
				"ext": "md",
				"name": "2014-12-12-new-build-system",
				"extname": ".md",
				"basename": "2014-12-12-new-build-system.md",
				"dirname": "posts",
				"stem": "2014-12-12-new-build-system",
				"path": "posts\\2014-12-12-new-build-system.md",
				"absolute": "C:\\Sites\\staystatic\\gatsby\\posts\\2014-12-12-new-build-system.md",
				"isAbsolute": false
			},
			"requirePath": "posts/2014-12-12-new-build-system.md",
			"path": "/posts/new-build-system/",
			"data": {
				"title": "football.db - New Build System - Welcome ./Datafile",
				"layout": "post",
				"path": "/posts/new-build-system/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "posts",
				"base": "2015-08-25-new-season.md",
				"ext": "md",
				"name": "2015-08-25-new-season",
				"extname": ".md",
				"basename": "2015-08-25-new-season.md",
				"dirname": "posts",
				"stem": "2015-08-25-new-season",
				"path": "posts\\2015-08-25-new-season.md",
				"absolute": "C:\\Sites\\staystatic\\gatsby\\posts\\2015-08-25-new-season.md",
				"isAbsolute": false
			},
			"requirePath": "posts/2015-08-25-new-season.md",
			"path": "/posts/new-season/",
			"data": {
				"title": "football.db - New 2015/16 Seasons - English Premier League, Bundesliga, And More",
				"layout": "post",
				"path": "/posts/new-season/"
			}
		}
	]
}


/*****************
 ** WEBPACK FOOTER
 ** ../config.toml
 ** module id = 363
 ** module chunks = 0
 **/